module.exports = __webpack_public_path__ + "img/mc.a897b0c7.png";